/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Block 1 = Log 2 = Ignore
 */
export type WAFPayloadLimitAction = 0 | 1 | 2;

export const WAFPayloadLimitAction = {
  Block: 0 as WAFPayloadLimitAction,
  Log: 1 as WAFPayloadLimitAction,
  Ignore: 2 as WAFPayloadLimitAction,
};
